"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Radio = _interopRequireDefault(require("../Radio"));

require("./radiobox.sass");

var Radiobox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Radiobox, _React$Component);

  function Radiobox() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Radiobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Radiobox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      active: !!_this.props.defaultChecked
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "ref", function (element) {
      _this.radiobox = element;
    });
    return _this;
  }

  (0, _createClass2.default)(Radiobox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["label", "name", "children"]);
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('form-field form-field--checkbox')
      }, _react.default.createElement("label", {
        onMouseDown: this.onMouseDown
      }, _react.default.createElement(_Radio.default, (0, _extends2.default)({}, props, {
        name: name,
        label: label,
        parrentRef: this.ref
      })), _react.default.createElement("span", {
        className: (0, _classnames.default)('radiobox-label', {
          'radiobox-label--disabled': props.disabled,
          'radiobox-label--readOnly': props.readOnly
        })
      }, children || label)));
    }
  }]);
  return Radiobox;
}(_react.default.Component);

exports.default = Radiobox;
Radiobox.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  greyscale: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onMouseMov: _propTypes.default.func
} : {};